import React from "react";
import Moment from "react-moment";
import { SOPInfoIcon } from "../../../../Components/IconComponents";
import "../SOPManagement.css";

// SOP master records expose the creator/updater as "created_by_name" /
// "updated_by_name" — fall back to a split first/last name pair or the raw
// email field in case a different SOP record shape is encountered.
const formatPerson = (data, prefix) => {
  const firstName = data?.[`${prefix}_firstname`];
  const lastName = data?.[`${prefix}_lastname`];
  if (firstName || lastName) return `${firstName || ""} ${lastName || ""}`.trim();
  return data?.[`${prefix}_name`] || data?.[`${prefix}Name`] || data?.[prefix] || "NA";
};

const SOPInfo = (props) => {
  return (
    <div className="container">
      <div className="row align-items-start">
        
        {/* Main Content */}
        <div className="col-md-10 mx-auto">
          <form className="mt-3 ps-3">

            {/* Row 1 — SOP Master ID | SOP Name | SOP Status */}
            <div className="row align-items-center">
              <div className="col-md-4">
                <label className="sop_label">SOP Master ID</label>
                <div className="sop_info_text">
                  {props.sopInstanceData.sopmaster_seq_id || "NA"}
                </div>
              </div>

              <div className="col-md-4">
                <label className="sop_label">SOP Name</label>
                <div className="sop_info_text">
                  {props.sopInstanceData.name}
                </div>
              </div>

              <div className="col-md-4">
                <label className="sop_label">SOP Status</label>
                <div className="sop_info_text">
                  {props.sopInstanceData.is_running === true ? (
                    <span
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "6px",
                        padding: "4px 10px", borderRadius: "5px",
                        color: "#92400E", background: "#FEF3C7",
                      }}
                    >
                      <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: "#F59E0B" }}></span>
                      Running
                    </span>
                  ) : (
                    <span
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "6px",
                        padding: "4px 10px", borderRadius: "5px",
                        color: "#64748B", background: "#F1F5F9",
                      }}
                    >
                      <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: "#94A3B8" }}></span>
                      Idle
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Row 2 — Incident Category | Severity | Created By */}
            <div className="row align-items-center mt-3">
              <div className="col-md-4">
                <label className="sop_label">Incident Category</label>
                <div className="sop_info_text">
                  {props.sopInstanceData.incident_type || "NA"}
                </div>
              </div>

              <div className="col-md-4">
                <label className="sop_label">Severity</label>
                <div className="sop_info_text">
                  {props.sopInstanceData.severity || "NA"}
                </div>
              </div>

              <div className="col-md-4">
                <label className="sop_label">Created By</label>
                <div className="sop_info_text">
                  {formatPerson(props.sopInstanceData, "created_by")}
                </div>
              </div>
            </div>

            {/* Row 3 — Created On | Updated By | Last Updated On */}
            <div className="row align-items-center mt-3">
              <div className="col-md-4">
                <label className="sop_label">Created On</label>
                <div className="sop_info_text">
                  <Moment format="DD-MM-YYYY, hh:mm A">
                    {props.sopInstanceData.created_on}
                  </Moment>
                </div>
              </div>

              <div className="col-md-4">
                <label className="sop_label">Updated By</label>
                <div className="sop_info_text">
                  {formatPerson(props.sopInstanceData, "updated_by")}
                </div>
              </div>

              <div className="col-md-4">
                <label className="sop_label">Last Updated On</label>
                <div className="sop_info_text">
                  <Moment format="DD-MM-YYYY, hh:mm A">
                    {props.sopInstanceData.updated_on}
                  </Moment>
                </div>
              </div>
            </div>

            {/* SOP Description — separate line */}
            <div className="row mt-3 mb-4">
              <div className="col-md-12">
                <label className="sop_label">SOP Description</label>
                <div className="sop_info_text">
                  {props.sopInstanceData.description}
                </div>
              </div>
            </div>

          </form>
        </div>

        {/* Icon */}
        <div className="col-md-2">
          <div className="mt-4">
            <SOPInfoIcon />
          </div>
        </div>

      </div>
    </div>
  );
};

export default SOPInfo;
